import script from "./NoticeModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./NoticeModal.vue?vue&type=script&setup=true&lang=ts"

import "./NoticeModal.vue?vue&type=style&index=0&id=9aa0ac06&scoped=true&lang=scss"

import exportComponent from "/var/www/twledodo-booking-rododo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9aa0ac06"]])

export default __exports__